/**
 * Detecção de dispositivo a partir do User-Agent.
 * Funciona tanto no browser quanto no server (passando o UA explicitamente).
 */
export type Device = "mobile" | "tablet" | "desktop";

export function detectDevice(ua?: string | null): Device {
  const userAgent = ua ?? (typeof navigator !== "undefined" ? navigator.userAgent : "");
  if (!userAgent) return "desktop";
  const s = userAgent.toLowerCase();
  if (/ipad|tablet|playbook|kindle|silk(?!-accelerated)/i.test(s)) return "tablet";
  if (/mobile|android|iphone|ipod|blackberry|iemobile|opera mini/i.test(s)) return "mobile";
  return "desktop";
}

export const MOBILE_UA =
  "Mozilla/5.0 (iPhone; CPU iPhone OS 17_0 like Mac OS X) AppleWebKit/605.1.15 (KHTML, like Gecko) Version/17.0 Mobile/15E148 Safari/604.1";
export const DESKTOP_UA =
  "Mozilla/5.0 (Macintosh; Intel Mac OS X 10_15_7) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/120.0.0.0 Safari/537.36";
